<template>
  <div class="shootingScore">
    <el-card class="parent-info-card" shadow="hover">
      <div class="shootingScore-type-info">
        <div class="info-row">
          <el-button icon="el-icon-back" @click="$router.back()" >返回</el-button>
          <div class="title-container">
            <span class="info-label">射手编号：</span>
            <span class="info-value">No. {{ shooterNo || '000000'}}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <span class="info-label">射手姓名：</span>
            <span class="info-value">{{ shooterName || '--'}}</span>
          </div>
        </div>
      </div>
    </el-card>

    <div class="shooting-page-container">
      <!-- 左侧：数据可视化区域 -->
      <div class="visual-area">
        <!-- 靶纸可视化容器 -->
        <div class="target-container">
          <!-- 靶纸背景 -->
          <div class="target-bg" :style="{ backgroundImage: 'url(' + require('@/assets/target-background.jpg') + ')'}"></div>
          <!-- 战区+靶编号（2区2号） -->
          <div class="war-target">
            {{ warZone }}区{{ targetNo }}号
          </div>
          <!-- 当前环数（0.0环） -->
          <div class="ring-score">
            {{ ringScore }} 环
          </div>
          <!-- 散布数据 -->
          <div class="dispersion-group">
            <div class="dispersion">射弹散布</div>
            <div class="dispersion-x">横向  {{ offsetX || '0000' }}</div>
            <div class="dispersion-y">纵向  {{ offsetY || '0000' }}</div>
          </div>
          <!-- 网格线 -->
          <div class="grid-lines">
            <div v-for="i in 51" :key="`h-${i}`" class="horizontal-line" :style="{ top: `${(i-1)*2}%` }"></div>
            <div v-for="i in 51" :key="`v-${i}`" class="vertical-line" :style="{ left: `${(i-1)*2}%` }"></div>
          </div>
          <!-- 弹着点（区分当前/历史发） -->
          <div 
            class="hit-point"
            v-for="(point, idx) in hitPointsList"
            :key="`hit-${idx}`"
            :style="{
              left: `${point.hitX / 50 * 100}%`,
              top: `${point.hitY / 50 * 100}%`,
              backgroundImage: `url(${point.imgSrc})`,
              width: pointSize,
              height: pointSize
            }"
          >
            <span class="shot-seq">{{ point.shotSeq }}</span>
          </div>
        </div>
      </div>
      <!-- 右侧：射击成绩区域 -->
      <div class="score-area">
        <!-- 射击成绩标题栏 -->
        <div class="score-title-bar">射击成绩</div>
        <!-- 成绩列表（超过10行容器内滚动） -->
        <div class="score-list-container">
          <table class="score-table">
            <thead>
              <tr>
                <th>发序</th>
                <th>命中数</th>
                <th>单枪成绩</th>
                <th>时间</th>
              </tr>
            </thead>
            <tbody ref="scoreTbody">
              <tr v-for="(record) in shootingRecords" :key="record.shotSeq">
                <td>{{ record.shotSeq }}</td>
                <td>{{ record.hitShotSeq }}</td>
                <td>{{ record.ringScore }}</td>
                <td>{{ record.shotDuration }}</td>
              </tr>
              <!-- 若数据不足10条，补空行（匹配默认10行） -->
              <tr v-for="i in Math.max(10 - shootingRecords.length, 0)" :key="`empty-${i}`">
                <td>0</td>
                <td>0</td>
                <td>0.0</td>
                <td>00:00.00</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 总数据区域（固定底部） -->
        <div class="total-data-bar">
          <div class="total-item">总发数</div>
          <div class="total-item">总命中数</div>
          <div class="total-item">总成绩</div>
          <div class="total-item">总用时</div>
        </div>
        <div class="total-data-value">
          <div class="total-value">{{ totalData.shotSeq }}</div>
          <div class="total-value">{{ totalData.hitShotSeq }}</div>
          <div class="total-value">{{ totalData.totalScore }}</div>
          <div class="total-value">{{ totalData.shotTotalDuration }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import recordApi from '../../api/record';
import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import config from '../../config/config';

export default {
  name: 'ShootingScore',
  data() {
    return {
      // WebSocket通信配置
      currentImei: '', // 当前设备的IMEI
      roundStatus: '0',// 是否射击结束
      stompClient: null,
      isConnected: false,
      subInstanceMap: {},
      wsEndpoint: config.WebSocketURL + '/ws',
      deviceTopicPrefix: '/topic/shooting-data/',

      // 页面业务数据
      warZone: '0',
      targetNo: '0',
      ringScore: '0.0',
      offsetX: '0000',
      offsetY: '0000',
      shooterNo: '000000', // 射手编号
      shooterName: '--', // 射手姓名
      hitPointsList: [], // 弹着点列表：{ hitX, hitY, shotSeq, imgSrc }
      shootingRecords: [], // 射击成绩列表：{ singleScore, time }
      totalData: { // 总数据（固定展示）
        shotSeq: '0',
        hitShotSeq: '0',
        totalScore: '0.0',
        shotTotalDuration: '00:00.00'
      },
      stopReceiving: false, // pkgType=2时停止处理数据
      hitPointImg: require('@/assets/hit-point.png'),
      hitPointLastImg: require('@/assets/hit-point-last.png'),

      tempHistoryRecords: [],
      tempHistoryHitPoints: []
    };
  },
  computed: {
    // 弹着点尺寸：坐标线间距的3倍距（自适应）
    pointSize() {
      return `${(100 / 50) * 3}%`; 
    },
  },
  mounted() {
    this.currentImei = this.$route.query.imei;
    this.roundStatus = this.$route.query.roundStatus;
    this.warZone = this.$route.query.target.warZone;
    this.targetNo = this.$route.query.target.targetNo;
    this.initWebSocket(); // 初始化WebSocket连接
  },
  watch: {
    // 监听射击记录数组的变化
    shootingRecords: {
      handler(newVal) {
        // 仅当数据超过10条时才自动滚动
        if (newVal.length > 10) {
          this.$nextTick(() => {
            // 获取tbody的DOM元素
            const tbody = this.$refs.scoreTbody;
            if (tbody) {
              // 核心：把滚动高度设为最大，直接滚到底部
              tbody.scrollTop = tbody.scrollHeight;
            }
          });
        }
      },
      deep: true // 深度监听，确保数组内部元素变化也能触发
    }
  },
  beforeDestroy() {
    this.unsubscribe(this.currentImei);
    this.disconnectWebSocket(); // 断开连接
  },
  methods: {
    // 初始化WebSocket（STOMP协议）
    initWebSocket() {
      // 1. 把SockJS包装成工厂函数传入Stomp.over
      this.stompClient = Stomp.over(() => new SockJS(this.wsEndpoint));
      // 2. 配置自动重连（可选，解决警告同时开启重连）
      this.stompClient.configure({
        autoReconnect: true, // 开启自动重连
        reconnectDelay: 5000, // 重连间隔5秒
        debug: () => {} // 关闭调试日志
      });
      this.stompClient.connect({}, 
        () => {
          this.isConnected = true;
          this.subscribeDeviceData(this.currentImei);
        },
        (err) => {
          this.isConnected = false;
          console.error('WebSocket连接失败：', err);
        }
      );
    },
    // 订阅指定设备的射击数据
    subscribeDeviceData(imei) {
      if (!this.stompClient || !this.isConnected || !imei) return;
      const topic = `${this.deviceTopicPrefix}${imei}`;
      const subInstance = this.stompClient.subscribe(topic, (msg) => {
        this.handleDeviceMessage(msg.body);
      });
      this.subInstanceMap[imei] = subInstance;
      // 根据订阅的imei重新发送进行中的历史报文
      recordApi.pushHistoryShootData(imei, this.roundStatus).then(res => {
        if (!res.success) {
          this.$message.error(res.message);
        }
      });
    },
    // 处理设备推送的报文
    handleDeviceMessage(content) {
      try {
        const msgObj = JSON.parse(content);
        const { pkgType } = msgObj;
        // 根据pkgType执行不同逻辑
        switch (pkgType) {
          case '1':
            // 开始处理数据
            this.stopReceiving = false;
            // 清空所有数据，重新写入射手编号、战区、靶号
            this.hitPointsList = [];
            this.shootingRecords = [];
            this.totalData = { shotSeq: '0', hitShotSeq: '0', totalScore: '0.0', shotTotalDuration: '00:00.00' };
            this.shooterNo = String(msgObj.shooterNo || '').padStart(6, '0');
            this.shooterName = msgObj.shooterName || '--';
            this.warZone = msgObj.warZone || '0';
            this.targetNo = msgObj.targetNo || '0';
            this.ringScore = '0.0';
            this.offsetX = '0000';
            this.offsetY = '0000';
            // 重置成绩列表滚动条到顶部
            this.$nextTick(() => {
              const tbody = this.$refs.scoreTbody;
              if (tbody) {
                tbody.scrollTop = 0;
              }
            });
            break;
          case '2':
            // 停止接收数据
            this.stopReceiving = true;
            break;
          case '3':
            if (this.stopReceiving) return; // pkgType=2时停止处理
            // 处理弹着点+成绩展示
            this.handleShootingData(msgObj);
            break;
          default:
            console.warn('未知pkgType：', pkgType);
        }
      } catch (e) {
        console.error('报文解析失败：', e);
      }
    },
    // 处理pkgType=3的射击数据
    handleShootingData(msgObj) {
      // 1. 获取报文原始XY值（未加1）
      const originHitX = Number(msgObj.hitX) || 0;
      const originHitY = Number(msgObj.hitY) || 0;
      const ringScore = Number(msgObj.ringScore) || 0;
      if (msgObj.msgType === 'HISTORY') {
        // 2. 判断不处理的情况：
        // 非XY都为0且原始XY都<50
        if (!((originHitX === 0 && originHitY === 0) || originHitX > 50 || originHitY > 50)) {
          if (ringScore !== 0) {
            // 1. 处理历史弹着点：上一发切换为普通图
            if (this.tempHistoryHitPoints.length > 0) {
              const lastPoint = { ...this.tempHistoryHitPoints.at(-1) };
              lastPoint.imgSrc = this.hitPointImg; // 普通图
              this.tempHistoryHitPoints.splice(this.tempHistoryHitPoints.length - 1, 1, lastPoint);
            }
            // 2. 计算最终弹着点坐标（加1后再做0-50边界兜底）
            const hitX = originHitX + 1;
            const hitY = originHitY + 1;
            // 3. 缓存当前发弹着点（用last图）
            this.tempHistoryHitPoints.push({
              hitX,
              hitY,
              shotSeq: msgObj.shotSeq || '0',
              imgSrc: this.hitPointLastImg // last图
            });
          }
        }
        // 2. 缓存射击成绩列表
        this.tempHistoryRecords.push({
          shotSeq: msgObj.shotSeq || '0',
          hitShotSeq: msgObj.hitShotSeq || '0',
          ringScore: msgObj.ringScore || '0.0',
          offsetX: this.formatFourDigits(msgObj.offsetX) || '0000',
          offsetY:this.formatFourDigits(msgObj.offsetY) || '0000',
          shotDuration: this.formatTimeToMMSSMS(msgObj.shotDuration) || '00:00.00', 
          totalScore: msgObj.totalScore || '0.0',
          shotTotalDuration: this.formatTimeToMMSSMS(msgObj.shotTotalDuration) || '00:00.00',
        });
        // 3. 判断是否接收完所有历史报文（核心：sequence+1 === total）
        const currentSeq = Number(msgObj.sequence);
        const total = Number(msgObj.total);
        if (currentSeq + 1 === total) {
          // 收完所有历史数据：按sequence排序（和后台SQL顺序完全一致）
          this.tempHistoryRecords.sort((a, b) => Number(a.sequence) - Number(b.sequence));
          this.tempHistoryHitPoints.sort((a, b) => Number(a.shotSeq) - Number(b.shotSeq));
          // 替换现有渲染列表（完全覆盖原有数据，避免混乱）
          this.shootingRecords = [...this.tempHistoryRecords];
          this.hitPointsList = [...this.tempHistoryHitPoints];
          // 更新总数据（总发数/总成绩/总用时）及靶面数据
          const lastHistoryMsg = this.tempHistoryRecords.at(-1);
          this.ringScore = lastHistoryMsg.ringScore || '0.0';
          this.offsetX = lastHistoryMsg.offsetX || '0000';
          this.offsetY = lastHistoryMsg.offsetY || '0000';
          this.totalData.shotSeq = lastHistoryMsg.shotSeq || '0';
          this.totalData.hitShotSeq = lastHistoryMsg.hitShotSeq || '0';
          this.totalData.totalScore = lastHistoryMsg.totalScore || '0.0';
          this.totalData.shotTotalDuration = lastHistoryMsg.shotTotalDuration || '00:00.00';
          // 清空临时缓存
          this.tempHistoryRecords = [];
          this.tempHistoryHitPoints = [];
        }
      }  else if (msgObj.msgType === 'REAL_TIME') {
        // 2. 判断不处理的情况：
        // 非XY都为0且原始XY都<50
        if (!((originHitX === 0 && originHitY === 0) || originHitX > 50 || originHitY > 50)) {
          if (ringScore !== 0) {
            // 1. 处理历史弹着点：上一发切换为普通图
            if (this.hitPointsList.length > 0) {
              const lastPoint = { ...this.hitPointsList.at(-1) };
              lastPoint.imgSrc = this.hitPointImg; // 普通图
              this.hitPointsList.splice(this.hitPointsList.length - 1, 1, lastPoint);
            }
            // 2. 计算最终弹着点坐标（加1后再做0-50边界兜底）
            const hitX = originHitX + 1;
            const hitY = originHitY + 1;
            // 3. 添加当前发弹着点（用last图）
            this.hitPointsList.push({
              hitX,
              hitY,
              shotSeq: msgObj.shotSeq || '0',
              imgSrc: this.hitPointLastImg // last图
            });
          }
        }
        // 2. 处理射击成绩列表及靶面信息
        this.ringScore = msgObj.ringScore || '0.0';
        this.offsetX = this.formatFourDigits(msgObj.offsetX) || '0000';
        this.offsetY = this.formatFourDigits(msgObj.offsetY) || '0000';
        this.shootingRecords.push({
          shotSeq: msgObj.shotSeq || '0',
          hitShotSeq: msgObj.hitShotSeq || '0',
          ringScore: msgObj.ringScore || '0.0',
          shotDuration: this.formatTimeToMMSSMS(msgObj.shotDuration) || '00:00.00', 
        });
        // 3. 更新总数据（总发数/总成绩/总用时）
        this.totalData.shotSeq = msgObj.shotSeq || '0';
        this.totalData.hitShotSeq = msgObj.hitShotSeq || '0';
        this.totalData.totalScore = msgObj.totalScore || '0.0';
        this.totalData.shotTotalDuration = this.formatTimeToMMSSMS(msgObj.shotTotalDuration) || '00:00.00';

        this.shootingRecords.sort((a, b) => Number(a.shotSeq) - Number(b.shotSeq));
        this.hitPointsList.sort((a, b) => Number(a.shotSeq) - Number(b.shotSeq));
      }
      
    },
    // 取消指定设备订阅
    unsubscribe(imei) {
      if (this.subInstanceMap[imei]) {
        this.subInstanceMap[imei].unsubscribe();
        delete this.subInstanceMap[imei];
      }
    },
    // 断开WebSocket连接
    disconnectWebSocket() {
      if (this.stompClient?.connected) {
        this.stompClient.disconnect();
      }
      this.isConnected = false;
    },
    // 格式化函数 - 不足四位前面补零，固定四位
    formatFourDigits(value) {
      // 先转成字符串，去除空值/非数字情况，默认值为'0'
      const str = (value || '0').toString();
      // padStart(4, '0')：不足4位时，在开头补0，直到长度为4
      return str.padStart(4, '0');
    },
    // 数字时间格式化为00:00.00
    formatTimeToMMSSMS(timeValue) {
      // 处理空值/非数字，默认0
      const timeNum = Number(timeValue) || 0;
      // 拆分：分钟 = 总秒数÷60；秒 = 总秒数%60；毫秒 = 小数部分×100（保留两位）
      const minutes = Math.floor(timeNum / 60);
      const seconds = Math.floor(timeNum % 60);
      const milliseconds = Math.round((timeNum - Math.floor(timeNum)) * 100);
      // 补零为两位字符串
      const fmtMin = String(minutes).padStart(2, '0');
      const fmtSec = String(seconds).padStart(2, '0');
      const fmtMs = String(milliseconds).padStart(2, '0');
      // 拼接成00:00.00格式
      return `${fmtMin}:${fmtSec}.${fmtMs}`;
    }
  }
};
</script>

<style scoped>
.shootingScore {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 占满整个视口高度 */
  overflow: hidden;
}
.parent-info-card {
  width: 100%;
  margin-bottom: 20px;
  border-left: 3px solid #409EFF;
  /* 保持标识性边框 */
  box-sizing: border-box;
  padding: 0 10px;
}
.shootingScore-type-info {
  font-size: 4vh;
  font-weight: bold;
}
.info-row {
  display: flex;
  align-items: center; /* 上下居中 */
  width: 100%;
}
.title-container {
  flex: 1;
  text-align: center;
}
/* 靶面容器：适配PC端不同显示器 */
.shooting-page-container {
  display: flex;
  width: 100%;
  flex: 1;
  gap: 0 15px;
  box-sizing: border-box;
  overflow: hidden;
  align-items: flex-start;
  padding: 0 10px; /* 可选：添加左右内边距，避免卡片贴边 */
}
/* 左侧可视化区域：保持正方形适配 */
.visual-area {
  display: flex;
  flex: 0 0 auto;
  flex-shrink: 0;
  height: 100%;
  aspect-ratio: 1/1;
  flex-direction: column;
}
/* 靶纸容器 */
.target-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border: 1px solid #000;
  overflow: hidden;
}
/* 靶纸背景图 */
.target-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
}
/* 战区+靶编号 */
.war-target {
  position: absolute;
  top: 10%;
  left: 5%;
  font-size: 5vh;
  font-weight: bold;
  color: #000;
  z-index: 10;
}
/* 当前环数 */
.ring-score {
  position: absolute;
  top: 5%;
  right: 1%;
  font-size: 7vh;
  font-weight: bold;
  color: #000;
  z-index: 10;
}
/* 散布数据 */
.dispersion-group {
  position: absolute;
  top: 20%;
  left: 5%;
  text-align: center;
  z-index: 10;
}
.dispersion, .dispersion-x, .dispersion-y {
  font-size: 3vh;
  font-weight: bold;
  color: #000;
}
/* 网格线（适配靶纸尺寸） */
.grid-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
}
.horizontal-line {
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #fff;
}
.vertical-line {
  position: absolute;
  top: 0;
  height: 100%;
  width: 1px;
  background-color: #fff;
}
/* 弹着点样式（居中对齐坐标） */
.hit-point {
  position: absolute;
  background-size: 100% 100%;
  transform: translate(-50%, -50%);
}
.shot-seq {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: 700;
  font-size: 100%;
}
/* 右侧成绩区域：拉长至底部 */
.score-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid #000;
}
/* 成绩标题 */
.score-title-bar {
  display: flex;
  height: 10%;
  background-color: #274b25; /* 深绿色背景 */
  color: #fff; /* 白色文字 */
  font-size: 6vh;
  font-weight: bold;
  align-items: center;
  justify-content: center;
}
/* 成绩列表容器：超过10行滚动 */
.score-list-container {
  height: calc(90% * 11 / 13);
  font-size: 2vh;
  box-sizing: border-box;
  overflow: hidden;
}
/* 成绩表格样式 */
.score-table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: center;
  border: none;
}
.score-table thead{
  display: table;
  width: 100%;
  table-layout: fixed;
  height: calc(100% / 11);
}
.score-table tbody{
  display: block;
  width: 100%;
  height: calc(100% * 10 / 11);
  overflow-y: overlay;
  overflow-x: hidden;
}
.score-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  height: 10%;
  box-sizing: border-box;
}
.score-table th {
  background-color: #274b25;
  color: #fff;
  font-weight: bold;
  border: 1px solid #000;
  width: 25%;
  height: 100%;
}
.score-table td {
  background-color: #fff;
  color: #000;
  border: 1px solid #000;
  width: 25%;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
}
/* 总数据栏：标题行（深绿背景+白字） */
.total-data-bar {
  display: flex;
  height: calc(90% / 13);
  font-size: 2vh;
  background-color: #274b25;
  color: #fff;
  font-weight: bold;
  border-bottom: none;
}
.total-data-bar .total-item {
  display: flex;
  flex: 1;
  height: 100%;
  text-align: center;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
}
/* 总数据栏：数值行（浅紫背景+黑字） */
.total-data-value {
  display: flex;
  height: calc(90% / 13);
  font-size: 2vh;
  background-color: #fff;
}
.total-data-value .total-value {
  display: flex;
  flex: 1;
  height: 100%;
  text-align: center;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
}
</style>